var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"karta",attrs:{"id":"karta"}},_vm._l((_vm.questions),function(question,index){return _c('div',{key:index,staticClass:"circle-line",class:{ hasBeen: _vm.atQuestion >= index }},[_c('div',{staticClass:"circle"})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9863efda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheKarta.vue
// module id = null
// module chunks = 